<template>
  <NavMenu />
  <section class="border-t">
    <div class="bg-brand-blue py-8 px-5">
      <div class="max-w-7xl mx-auto">
        <div class="text-white">
          <div class="">
            <div class="text-sm font-bold text-gray-200 mb-5">
              Home / resources
            </div>
            <h1 class="text-3xl font-bold">Resources</h1>
          </div>
        </div>
      </div>
    </div>
    <div class="py-20">
      <div class="max-w-7xl mx-auto">
        <div>
          <div class="grid mb-8 lg:grid-cols-2 gap-5">
            <div class="space-x-2">
              <!-- <span
                @click="
                  filteredCatId = '';
                  filterRows();
                "
                :class="[
                  filteredCatId == ''
                    ? ' bg-blue-600 text-white'
                    : 'bg-slate-300',
                ]"
                class="px-5 py-2 text-sm rounded-full cursor-pointer"
                >All</span
              > -->
              <span
                @click="
                  filteredCatId = row.name;
                  filterRows();
                "
                :class="[
                  filteredCatId == row.name
                    ? ' bg-blue-600 text-white'
                    : 'bg-slate-300',
                ]"
                class="px-5 py-2 text-sm rounded-full cursor-pointer"
                v-for="row in documentCategories"
                :key="row.id"
                >{{ row.name }}</span
              >
            </div>
            <div class="lg:flex justify-end">
              <input
                v-model="searchStr"
                type="search"
                placeholder="Search documents"
                class="form-control rounded-full w-full lg:w-60"
              />
            </div>
          </div>
          <!-- <pre>
            {{searchList}}
          </pre> -->
          <div class="grid lg:grid-cols-3 gap-8" v-if="searchList.length > 0">
            <a
              :href="row.documentUrl"
              target="_blank"
              class="
                flex
                space-x-3
                p-5
                rounded-xl
                bg-gray-100
                hover:bg-gray-200
                transition-all
              "
              v-for="(row, i) in searchList"
              :key="i"
            >
              <div><DocumentTextIcon class="w-6 h-6" /></div>
              <div>
                <div class="font-bold text-lg">
                  {{ row.documentName }}
                </div>
                <div class="text-gray-500">
                  {{ row.websiteDocumentCategory }}
                </div>
              </div>
            </a>
          </div>
          <div class="grid lg:grid-cols-3 gap-8" v-else>
            <a
              :href="row.documentUrl"
              target="_blank"
              class="
                flex
                space-x-3
                p-5
                rounded-xl
                bg-gray-100
                hover:bg-gray-200
                transition-all
              "
              v-for="(row, i) in filteredRows"
              :key="i"
            >
              <div><DocumentTextIcon class="w-6 h-6" /></div>
              <div>
                <div class="font-bold text-lg">
                  {{ row.documentName }}
                </div>
                <div class="text-gray-500">
                  {{ row.websiteDocumentCategory }}
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
  <SectionFooter />
</template>

<script setup>
import NavMenu from "@/components/NavMenu";
import { DocumentTextIcon } from "@heroicons/vue/outline";
import SectionFooter from "@/components/SectionFooter";
import { useStore } from "vuex";
import { computed, onMounted, ref } from "@vue/runtime-core";

const store = useStore();
const rows = computed(() => store.getters["document/data"].rows);
const documentCategories = computed(
  () => store.getters["documentCategory/data"].rows
);
let filteredRows = ref([]);
let filteredCatId = ref("");

onMounted(() => {
  document.title = "Resources - The Coral Database";
  document
    .querySelector('meta[name="description"]')
    .setAttribute("content", "Resources at the Coral Database");
});

store
  .dispatch("http/send", {
    module: "documentCategory",
  })
  .then(() => {
    filteredCatId.value = documentCategories.value[0].name;
  });
store
  .dispatch("http/send", {
    module: "document",
  })
  .then(() => {
    filterRows();
  });

let searchStr = ref("");
let searchList = computed(() => {
  var forms = [];
  if (searchStr.value.indexOf(" ") > 0) {
    let words = searchStr.value.split(" ");
    forms = [];
    words.forEach((word) => {
      if (word.length > 1) {
        rows.value.forEach((element) => {
          if (formSearch(word, element)) {
            if (!forms.find((f) => f.id == element.id)) {
              forms.push(element);
            }
          }
        });
      }
    });
  } else if (searchStr.value.length > 1) {
    rows.value.forEach((element) => {
      if (formSearch(searchStr.value, element)) {
        // console.log("Found");
        forms.push(element);
      }
    });
  } else {
    // forms = this.apps.applications;
  }
  return forms;
});

function formSearch(searchQuery, element) {
  //   console.log(element);
  var keywords = element["documentName"] ? element["documentName"] : "";
  if (keywords.toLowerCase().includes(searchQuery.toLowerCase())) {
    return true;
  } else {
    return false;
  }
}

function filterRows() {
  if (filteredCatId.value != "") {
    filteredRows.value = [];
    rows.value.forEach((element) => {
      if (element.websiteDocumentCategory == filteredCatId.value) {
        filteredRows.value.push(element);
      }
    });
  } else {
    filteredRows.value = rows.value;
  }
}
</script>